import { all } from 'redux-saga/effects';
import TrialUserSaga from './TrialAcctUser/saga';
import LayoutSaga from './layout/saga';
import loginSaga from './login/saga';
import ForgetPasswordSaga from './forgetPwd/saga';
import addUserSaga from './CognitoUser/saga';
export default function* rootSaga() {
    yield all([
        TrialUserSaga(),
        LayoutSaga(),
        loginSaga(),
        ForgetPasswordSaga(),
        addUserSaga(),
    ]);
}